/**
 * Who did what to a device (`api/device_notes.py`): names and times beside
 * what the live documents say. Polled, because a note changes when a person
 * presses something, not at the rate of telemetry.
 */
import { useQuery } from '@tanstack/react-query';
import { useSafeSiteId } from '../../state/useActiveSite';
import { fetchDeviceNotes, type DeviceNotes } from '../v1-client';
import type { SiteId } from '../v1';

export function useDeviceNotes() {
  const siteId = useSafeSiteId();
  return useQuery<DeviceNotes | null>({
    queryKey: ['v1', siteId || '__none__', 'device-notes'],
    queryFn: () => fetchDeviceNotes(siteId as SiteId),
    enabled: Boolean(siteId),
    staleTime: 10_000,
    refetchInterval: 15_000,
  });
}
